import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class NotificationSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success =
      serverRes.statusCode == 200 ||
      serverRes.statusCode == 201 ||
      serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: NOTIFICATION_ERR_${serverRes.statusCode || raw.status || '1000'}`,
        data: null
      };
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Notifications got',
      data: (Array.isArray(serverRes?.data) ? serverRes.data : [])
        .map((item) => {
          const notif = item.appInfo || {};
          return {
            id: item.userId,
            title: notif.title,
            description: notif.description,
            country: notif.country || 'ANY',
            date: notif.date || item.createdAt || null
          };
        })
        .sort((a, b) => {
          const timeA = a.date ? new Date(a.date).getTime() : 0;
          const timeB = b.date ? new Date(b.date).getTime() : 0;
          return timeB - timeA;
        })
    };
  }

  serialize(newNotification) {
    return {
      appInfo: {
        title: newNotification.title,
        description: newNotification.description,
        country: newNotification.country || 'ANY',
        date: newNotification.date || new Date().toISOString()
      }
    };
  }
}

export const serializer = new NotificationSerializer();
